import axios from "axios";

export const updateInvoiceStatus = async (
  idInvoice,
  newStatus,
  interesFlag, // Pasar el nuevo parámetro
  metaData,
  detail
) => {
  const data = JSON.stringify({
    idInvoice,
    newStatus,
    interesFlag, // Pasar el nuevo parámetro
    metaData,
    detail,
  });
  debugger

  const url = window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';
  const config = {
    method: "POST",

    url: `http://${url}:4000/api/v1/boletaDigital/updateInvoiceStatus`,
    //url: "http://localhost:4000/api/v1/boletaDigital/updateInvoiceStatus",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response = axios(config);
    return await response;
  } catch (error) {
    const { response } = error;
    return await response;
  }
};
